module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "applySuccess"
  }, [_c('mt-header', {
    attrs: {
      "title": "申请成功"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.project
    },
    slot: "right"
  }, [_vm._v("完成")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', [_c('icon', {
    attrs: {
      "name": "check-circle"
    }
  }), _vm._v("申请成功")], 1), _vm._v(" "), _c('p', [_vm._v("申请意向发送成功!项目方如果对你感兴趣，会主动和您联系，届时请及时查看并回复消息。")])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.project
    }
  }, [_vm._v("查看我的申请")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01d70ddd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/applySuccess.vue
// module id = 1253
// module chunks = 1